import { useQuery } from '@tanstack/react-query';
import { Typography } from 'src/components/Typography';
import { Exercise } from 'src/models/exercise/_types';
import { fetchExercise } from 'src/models/exercise/exercise';
import { ExerciseAutocomplete } from 'src/shared/Forms/Selects/ExerciseAutocomplete';
import { Identifier } from 'src/types/utilityTypes';

interface ExerciseFilterProps {
  label: string;
  value: string | Identifier | undefined;
  setValue: (newVal: string | Identifier) => void;
  valueOnly?: boolean;
  onChange?: (newVal: Exercise | null) => void;
}

export const ExerciseFilter: React.FC<ExerciseFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  onChange,
}) => {
  const { data: exercise } = useQuery<Exercise>({
    queryKey: ['exercise', value],
    queryFn: () => fetchExercise({ id: value! }),
    enabled: !!value && valueOnly,
  });

  if (valueOnly) {
    return <>{exercise?.name || ''}</>;
  }

  const selectedExercise = exercise
    ? {
        id: exercise.id,
        name: exercise.name,
      }
    : null;

  return (
    <>
      <Typography>{label}</Typography>
      <ExerciseAutocomplete
        label=""
        value={selectedExercise}
        onChange={(newValue) => {
          onChange?.(newValue);
          setValue(newValue?.id || '');
        }}
      />
    </>
  );
};
